$(document).ready(function () {
	// Artikel löschen
	$(".wako_del").click(function (){
		var form	= $(this).closest("form");
		var id		= $(this).attr("id").replace("wako_del_","");
		$("input[name=wako_anzahl_" + id +"]").val("0");
		$("button[name=wako_btn_submit_recalculate]").click();
	});
	// Lieferadresse Click
	$(".lieferadresse-content").click(function() {
		var lieferadresse_id = $(this).attr("id").replace("lieferadresse-content-","");
		toggle_lieferadresse_bearbeiten(lieferadresse_id);
		$("#l_" + lieferadresse_id).prop("checked", true);
	});
	// Bestellung Details anzeigen
	$(".bestellungen-detail").click(function (){
		var id = $(this).attr("id").replace("bestellungen_detail_","");
		if ($("#wako_bestellungen_artikel_" + id).html() == '') {
			$("#wako_bestellungen_artikel_" + id).removeClass("display-none");
			$("#wako_bestellungen_artikel_" + id).addClass("display-block");
			$("#wako_bestellungen_artikel_" + id).html(spinner);
			$("#details_oben_" + id).removeClass("display-block");
			$("#details_oben_" + id).addClass("display-none");
			$.ajax ({
				type: 'GET',
				url: '/warenkorb/ajax_bestellung_details',
				data: 'bestellung_id=' + id,
				cache: false,
				success: function (html) {
					$("#wako_bestellungen_artikel_" + id).html(html);
					$("#details_unten_" + id).removeClass("display-none");
					$("#details_unten_" + id).addClass("display-block");
				}
			});
		}
	});
});

//Anzahl erneuern im Warenkorb

function recount(){
	$("button[name='wako_btn_submit_recalculate']").click();
}

// OPEN / CLOSE

function close_overlay(element){
	$(element).hide();
}
function open_overlay(element){
	$(element).show();
}

function toggle_lieferadresse() {
	if ($("input[name='rechnungsadresse_ist_lieferadresse']:checked").val() == '0') {
		$("#wako_form_lieferadresse").show();
	} else {
		$("#wako_form_lieferadresse").hide();
	}
}

//Add Article Funktion

function warenkorb_add(artikel_id,artikel_typ,tracking_aktiv,behrsnummer,preis,ga_vier_aktiv) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_add_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ + '&tracking_aktiv=' + tracking_aktiv + '&behrsnummer=' + behrsnummer + '&preis=' + preis  + '&ga_vier_aktiv=' + ga_vier_aktiv
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				if (tracking_aktiv == 1 && cookiemanager.accepted_statistics) {
					if ( ga_vier_aktiv == 1 ) {
						gtag('event', 'add_to_cart', {
							"items": [
								{
									"id": behrsnummer,
									"quantity": 1,
									"price": preis
								}
							]
						});
						gtag('event', 'Insert', {
							'event_category': 'Warenkorb',
							'event_label'	: 'Behrsnummer ' + behrsnummer
						});
					}
					ga('send','event','Warenkorb','Insert','Behrsnummer ' + behrsnummer);
					ga('set','ecomm_pagetype','basket');
					ga('set','ecomm_prodid',behrsnummer);
					ga('set','ecomm_totalvalue',preis);
				} else {
					console.info("ga('send','event','Warenkorb','Insert','Behrsnummer ' + behrsnummer);");
					console.info(behrsnummer);
					console.info(preis);
					console.info(cookiemanager.accepted_statistics);
					console.info(tracking_aktiv);
				}
				window.parent.update_wakobox_and_show($('basket_count', xml).text());
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Artikel konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

function warenkorb_add_seminar(seminar_id,redirect_link,tracking_aktiv,behrsnummer,preis,ga_vier_aktiv) {
	$.ajax({
		type: 'GET'
		,url: '/seminar-warenkorb/ajax_add_seminar'
		,data: 'seminar_id=' + seminar_id + '&redirect_link=' + redirect_link + '&tracking_aktiv=' + tracking_aktiv + '&behrsnummer=' + behrsnummer + '&preis=' + preis
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				if (tracking_aktiv == 1 && cookiemanager.accepted_statistics) {
					if ( ga_vier_aktiv == 1 ) {
						gtag('event', 'add_to_cart', {
							"items": [
								{
									"id": behrsnummer,
									"quantity": 1,
									"price": preis
								}
							]
						});
						gtag('event', 'Insert', {
							'event_category': 'Seminar-Warenkorb',
							'event_label'	: 'Behrsnummer ' + behrsnummer
						});
					}
					ga('send','event','Seminar-Warenkorb','Insert','Behrsnummer ' + behrsnummer);
					ga('set','ecomm_pagetype','basket');
					ga('set','ecomm_prodid',behrsnummer);
					ga('set','ecomm_totalvalue',preis);
				} else {
					console.info("ga('send','event','Seminar-Warenkorb','Insert','Behrsnummer ' + behrsnummer);");
					console.info(behrsnummer);
					console.info(preis);
					console.info(cookiemanager.accepted_statistics);
				}
				// Redirect in Seminar Warenkorb wenn Titel erfolgreich aufgenommen werden konnte
				window.location.href = redirect_link;
			}
			else {
				alert("Das Seminar konnte nicht in den Warenkorb gelegt werden.");
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Seminar konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

//Warenkorb Delete Funktion

function warenkorb_delete(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_delete_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				window.parent.update_wakobox_and_show($('basket_count', xml).text());
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht gelöscht werden.");
		}
	});
}

// Warenkorb Overlay updaten und anzeigen

function update_wakobox_and_show(basket_count,open=false) {
	$.ajax({
		url: '/warenkorb/ajax_shopping_cart',
		type: "POST",
		success: function(html,textStatus){
			$("#shopping_cart_overlay").replaceWith(html);
			$("#shopping_cart_overlay").show();
			console.log('basket_count --> ',basket_count);
			if (open === false) {
				if (basket_count === '0') {
					$(".wako-count-header").removeClass('d-inline-block');
					$(".wako-count-header").addClass('d-none');
					$(".wako-count-header-mobile").removeClass('d-inline-block');
					$(".wako-count-header-mobile").addClass('d-none');
				} else {
					$(".wako-count-header").removeClass('d-none');
					$(".wako-count-header").addClass('d-inline-block');
					$(".wako-count-header-mobile").removeClass('d-none');
					$(".wako-count-header-mobile").addClass('d-inline-block');
				}
				$(".wako-count-header").html(basket_count);
				$(".wako-count-header-mobile").html(basket_count);
			}
		},
		error: function(){
			alert("Beim Laden des Warenkorbs ist ein Fehler aufgetreten.")
		}
	});
}

// Toggle Lieferadresse bearbeiten

function toggle_lieferadresse_bearbeiten(lieferadresse_id) {
	if ($("#bearbeiten_" + lieferadresse_id).is(":visible") == 0) {
		$('.lieferadresse_bearbeiten_links').hide();
		$("#bearbeiten_" + lieferadresse_id).show();
	}
}

// Check for Address Type

function change_adress_type(address,address_type,ary_eu_auslands_ids) {

	if (address == 'R') {
		var rechnungsadresse_land_id = Number($('#rechnungsadresse_land_id').val());
		if (address_type == 'F') {
			$("#firm_up").addClass("show_firma_up");
			$("#firm_down").addClass("hide_firma_down");
			$("#firm_up").removeClass("hide_firma_up");
			$("#firm_down").removeClass("show_firma_down");
			$("#firm_down #rechnungsadresse_firma").val('');
			$("#firm_up #rechnungsadresse_firma").val('');
			$("#r-firma-mandatory").removeClass("hide-r-ui-mandatory");
			$("#r-firma-mandatory").addClass("show-r-ui-mandatory");
			if (ary_eu_auslands_ids.indexOf(rechnungsadresse_land_id) >= 0 && rechnungsadresse_land_id !== 56) {
				$("#r-ui-mandatory").removeClass("hide-r-ui-mandatory");
				$("#r-ui-mandatory").addClass("show-r-ui-mandatory");
			} else {
				$("#r-ui-mandatory").removeClass("show-r-ui-mandatory");
				$("#r-ui-mandatory").addClass("hide-r-ui-mandatory");
			}
		} else {
			$("#firm_up").removeClass("show_firma_up");
			$("#firm_down").removeClass("hide_firma_down");
			$("#firm_up").addClass("hide_firma_up");
			$("#firm_down").addClass("show_firma_down");
			$("#firm_down #rechnungsadresse_firma").val('');
			$("#firm_up #rechnungsadresse_firma").val('');
			$("#r-ui-mandatory, #r-firma-mandatory").removeClass("show-r-ui-mandatory");
			$("#r-ui-mandatory, #r-firma-mandatory").addClass("hide-r-ui-mandatory");
		}
	} else if (address == 'L') {
		var lieferadresse_land_id = Number($('#lieferadresse_land_id').val());
		if (address_type == 'F') {
			$("#firm_up").addClass("show_firma_up");
			$("#firm_down").addClass("hide_firma_down");
			$("#firm_up").removeClass("hide_firma_up");
			$("#firm_down").removeClass("show_firma_down");
			$("#firm_down #lieferadresse_firma").val('');
			$("#firm_up #lieferadresse_firma").val('');
			$("#l-firma-mandatory").removeClass("hide-l-ui-mandatory");
			$("#l-firma-mandatory").addClass("show-l-ui-mandatory");
			if (ary_eu_auslands_ids.indexOf(lieferadresse_land_id) >= 0 && lieferadresse_land_id !== 56) {
				$("#l-ui-mandatory").removeClass("hide-l-ui-mandatory");
				$("#l-ui-mandatory").addClass("show-l-ui-mandatory");
			} else {
				$("#l-ui-mandatory, #l-firma-mandatory").removeClass("show-l-ui-mandatory");
				$("#l-ui-mandatory, #l-firma-mandatory").addClass("hide-l-ui-mandatory");
			}
		} else {
			$("#firm_up").removeClass("show_firma_up");
			$("#firm_down").removeClass("hide_firma_down");
			$("#firm_up").addClass("hide_firma_up");
			$("#firm_down").addClass("show_firma_down");
			$("#firm_down #lieferadresse_firma").val('');
			$("#firm_up #lieferadresse_firma").val('');
			$("#l-ui-mandatory, #l-firma-mandatory").removeClass("show-l-ui-mandatory");
			$("#l-ui-mandatory, #l-firma-mandatory").addClass("hide-l-ui-mandatory");
		}
	}
}

// Change Wako Land

function change_wako_land(ary_eu_auslands_ids,address) {
	if (address == 'R') {
		var rechnungsadresse_land_id = Number($('#rechnungsadresse_land_id').val());
		var address_type = 'F';
		if (document.getElementById('rechnungsadresse_art_p').checked) {
			address_type = 'P'
		}
		if (address_type == 'F') {
			if (ary_eu_auslands_ids.indexOf(rechnungsadresse_land_id) >= 0 && rechnungsadresse_land_id !== 56) {
				$("#r-ui-mandatory, #r-firma-mandatory").removeClass("hide-r-ui-mandatory");
				$("#r-ui-mandatory, #r-firma-mandatory").addClass("show-r-ui-mandatory");
			} else {
				$("#r-ui-mandatory, #r-firma-mandatory").removeClass("show-r-ui-mandatory");
				$("#r-ui-mandatory, #r-firma-mandatory").addClass("hide-r-ui-mandatory");
			}
		} else {
			$("#r-ui-mandatory, #r-firma-mandatory").removeClass("show-r-ui-mandatory");
			$("#r-ui-mandatory, #r-firma-mandatory").addClass("hide-r-ui-mandatory");
		}
	} else if (address == 'L') {
		var lieferadresse_land_id = Number($('#lieferadresse_land_id').val());
		var address_type = 'F';
		if (document.getElementById('lieferadresse_art_p').checked) {
			address_type = 'P'
		}
		if (address_type == 'F') {
			$("#l-firma-mandatory").removeClass("hide-l-ui-mandatory");
			$("#l-firma-mandatory").addClass("show-l-ui-mandatory");
			if (ary_eu_auslands_ids.indexOf(lieferadresse_land_id) >= 0 && lieferadresse_land_id !== 56) {
				$("#l-ui-mandatory").removeClass("hide-l-ui-mandatory");
				$("#l-ui-mandatory").addClass("show-l-ui-mandatory");
			} else {
				$("#l-ui-mandatory").removeClass("show-l-ui-mandatory");
				$("#l-ui-mandatory").addClass("hide-l-ui-mandatory");
			}
		} else {
			$("#l-ui-mandatory, #l-firma-mandatory").removeClass("show-l-ui-mandatory");
			$("#l-ui-mandatory, #l-firma-mandatory").addClass("hide-l-ui-mandatory");
		}
	}
}
